import Vue from 'vue';

const Vues = new Vue();
export default Vues;
